<template>
    <component
        :is="blockType"
        :block-data="data"
        :slideNum="slideNum"
        :text-dir="textDir"
        :is-rtl="isRtl"
        :active="active"
    />
</template>

<script>

import {
    AccordianInformationBlock,
    AudioBlock,
    EmbedBlock,
    FlashInformationBlock,
    HotspotBlock,
    ImageBlock,
    ImageOverlayBlock,
    IntroBlock,
    KeyInformationBlock,
    QuizBlock,
    QuoteBlock,
    StyledListBlock,
    StyledTextBlock,
    TabsBlock,
    TextBlock,
    VideoBlock,
} from '@/components/courses/blocks';

export default {
    name: 'CourseSlide',
    components: {
        AccordianInformationBlock,
        AudioBlock,
        EmbedBlock,
        FlashInformationBlock,
        HotspotBlock,
        ImageBlock,
        ImageOverlayBlock,
        IntroBlock,
        KeyInformationBlock,
        QuizBlock,
        QuoteBlock,
        StyledListBlock,
        StyledTextBlock,
        TabsBlock,
        TextBlock,
        VideoBlock,
    },

    props: {
        slideNum: {
            type: Number,
            default: null
        },
        active: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        textDir: {
            type: String,
            default: 'ltr',
        },
        isRtl: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {

        };
    },

    computed: {
        blockType() {
            let blockType = this.data.type.replace(/_/g, '-');

            if (!blockType.includes('-block')) {
                blockType = `${blockType}-block`;
            }

            return blockType;
        },
    },

    methods:{},
};
</script>
